import { Constants, IOrganizationsState } from './types'

const initialState: IOrganizationsState = {
  list: [],
  current: null,
}

export function organizationsReducer(
  state = initialState,
  action: any,
): IOrganizationsState {
  switch (action.type) {
    case Constants.GET_ORGANIZATIONS:
      return {
        ...state,
        list: action.payload,
      }
    case Constants.SET_CURRENT:
      return {
        ...state,
        current: action.payload,
      }
    default:
      return state
  }
}

export default organizationsReducer
